import React, { useContext } from 'react'
import { Form, Input, Space } from 'antd'
import { FormLayoutRow, Well } from '@pushly/aqe/lib/components'
import { PromptBehavior } from '@pushly/models/lib/structs/prompts/prompt-behavior'
import { DEFAULT_COOKIE_LENGTH_SECONDS } from '../constants'
import { PromptEditorDispatchContext } from '../reducer'
import { PromptEditorContext } from '../context'
import { daysToSeconds, isNullOrUndefined, secondsToDays } from '@pushly/aqe/lib/utils'

export const PromptBehaviorEditor = () => {
    const dispatch = useContext(PromptEditorDispatchContext)
    const { loading, selectedPrompt, selectedPromptIdx } = useContext(PromptEditorContext)

    const behavior = selectedPrompt?.config?.behavior
    const cookieLenSeconds = !isNullOrUndefined(behavior?.cookieLengthSeconds)
        ? behavior!.cookieLengthSeconds
        : DEFAULT_COOKIE_LENGTH_SECONDS

    const setBehavior = (setter: (behavior: PromptBehavior) => PromptBehavior) => {
        const update = selectedPrompt!.clone()
        const behaviorUpdate = behavior?.clone() ?? new PromptBehavior()
        update.config!.behavior = setter(behaviorUpdate)
        dispatch({ type: 'set-prompt', idx: selectedPromptIdx!, prompt: update })
    }

    return (
        <Well title="Behaviors" hideFooter={true} mode="ghost" flush>
            <Form.Item layout="vertical" label="Re-show Dismissed Prompt After">
                {!loading && (
                    <Space.Compact>
                        <Input
                            key={selectedPromptIdx}
                            placeholder="7"
                            type="number"
                            defaultValue={secondsToDays(cookieLenSeconds)}
                            onChange={(ev) => {
                                setBehavior((update) => {
                                    if (!ev.target.value) {
                                        update.cookieLengthSeconds = null!
                                    } else {
                                        try {
                                            update.cookieLengthSeconds = daysToSeconds(parseInt(ev.target.value, 10))
                                        } catch (e) {
                                            console.error(e)
                                        }
                                    }

                                    return update
                                })
                            }}
                            style={{ width: 100 }}
                        />
                        <Space.Addon>
                            <span>day(s)</span>
                        </Space.Addon>
                    </Space.Compact>
                )}
            </Form.Item>
        </Well>
    )
}
